import {
  fileDowload,
  fileParameters,
  IFileCollection,
  lotDetails,
  lotFileDownload,
  lotList,
  sponsorBylotPayload,
  subsidy,
  uploadFileParams,
  zeroFileParams,
} from 'models/file';
import { defaultResponse } from 'models/response';
import { axiosEndPoint } from 'utils/axios';

const path = '/aws/files';

export const postFile = async (
  file: File,
  params: fileParameters
): Promise<IFileCollection> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axiosEndPoint.post<IFileCollection>(
    `${path}/upload-with-category`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params,
    }
  );
  return response.data;
};

export const getFilesByCategory = async (
  category: string
): Promise<IFileCollection[]> => {
  const response = await axiosEndPoint.get<IFileCollection[]>(
    `${path}/category/${category}`
  );
  return response.data;
};

export const getFileById = async (id: string): Promise<Blob> => {
  const response = await axiosEndPoint.get<Blob>(`${path}/${id}/file`, {
    responseType: 'blob',
  });
  return response.data;
};

export const getZeroFile = async (
  payload: zeroFileParams
): Promise<fileDowload> => {
  const response = await axiosEndPoint.get('files/fileStandardZero', {
    params: payload,
    timeout: Infinity,
    responseType: 'blob',
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    `PRECE_Padrao_0_${
      new Date(payload.dateReference).getMonth() + 1
    }-${new Date(payload.dateReference).getFullYear()}.txt`
  );
  document.body.appendChild(link);
  link.click();
  link.remove();

  return response.data;
};
export const postDataFile = async (
  payload: uploadFileParams
): Promise<defaultResponse> => {
  const response = await axiosEndPoint.post<defaultResponse>(
    'files/readerFiles',
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const getLotList = async (): Promise<lotList> => {
  const response = await axiosEndPoint.get<lotList>('files/lotList');
  return response.data;
};

export const postProcessingBySponsor = async (
  payload: sponsorBylotPayload
): Promise<subsidy> => {
  const response = await axiosEndPoint.post<subsidy>(
    'files/processingBySponsor',
    payload
  );
  return response.data;
};

export const getLotDetails = async (lot: number): Promise<lotDetails> => {
  const response = await axiosEndPoint.get<lotDetails>(
    `files/lotDetail/${lot}`
  );
  return response.data;
};

export const getUsuariosAcDc = async (
  payload: lotFileDownload
): Promise<fileDowload> => {
  const response = await axiosEndPoint.get('files/lotFile', {
    params: payload,
    timeout: Infinity,
    responseType: 'blob',
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${payload.type}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();

  return response.data;
};
